import Header from "../Header";
import React, {useEffect, useState} from "react";
import {useForm} from "react-hook-form";
import {createConditionalRequire} from "../../utils";
import {submitStep} from "../../network";
import ReactGA from "react-ga";

const MutualAgreement = ({nextStep, currentFormStep, maxStep}) => {
    useEffect(() => {
        ReactGA.pageview(window.location.pathname + "/mutualAgreement");
    }, []);
    const [isLoading, setLoading] = useState(false);
    const onSubmit = data => {
        setLoading(true)
        submitStep("mutual agreement", data)
            .then(() => {
                setLoading(false)
                nextStep()
            })
    };
    const {register, handleSubmit, errors, getValues} = useForm();
    return (<>
        <Header title="Lepime kokku, mida üksteiselt ootame!"/>
        <progress className="progress is-link" value={currentFormStep} max={maxStep}/>
        <section className="section">

        <div className="container">
                <figure className="image video-container">
                    <iframe className="has-ratio video-iframe"
                            src="https://www.youtube.com/embed/89jnt4QsMQM?showinfo=0" frameborder="0"
                            allowfullscreen/>
                </figure>
            </div>
            <div className="container">
                <p className="text">
                    Ülikoolis, nagu ka muus elus, on kõige parem teha koostööd siis, kui rääkida avatud tekstiga ootused läbi ja katsuda leppida milleski kokku. 
                    Teen Sulle ettepaneku leppida kokku järgnevas:
                </p>
            </div>

            <div className="container">
                <h1 className="subtitle">
                    Meie lubame, et:
                </h1>
                <ul className="list">
                    <li>
                        Teeme Su jaoks nii põneva kursuse, kui oskame. 
                        Oleme tiimiga pingutanud terve suve, et valmistuda ja võtta arvesse eelmise aasta tagasisidet!
                    </li>
                    <li>
                        Tuleme Sulle ülesannete lahendamisel ja õppimisel appi! 
                        Oleme kättesaadavad praktikumide ajal (kui ka tekib järjekord, siis jõuame Sinuni, isegi kui selleks kulub natuke aega).
                    </li>
                    <li>
                        Sa saad oma ülesannet kaitsta välja lubatud päeval.
                    </li>
                    <li>
                        Vastame Su esitatud küsimustele, näiteks Discordis.
                    </li>
                    <li>
                        Küsime regulaarselt tagasisidet ja arvestame sellega!
                    </li>
                    <li>
                        Suur osa kursusest on loodud nii, et seda saab läbida ka virtuaalselt.
                    </li>
                    <li>
                        Kui jääd päriselt hätta ja tundub, et olukord on lootusetu – ka siis kuulame Su ära ja leiame lahenduse!
                    </li>
                </ul>
            </div>

            <div className="container">
                <h1 className="subtitle">
                    Me ootame Sinult, et:
                </h1>
                <ul className="list">
                    <li>
                        Kui läheb raskeks, küsid julgelt abi. Sõnasta oma mure kohe, kui jääd hätta, et me kindlasti jõuaksime Sind aidata. Me oleme kõik tudengid, või oleme need olnud, ja ühel või teisel hetkel hädas olnud.
                    </li>
                    <li>
                        Teed ülesandeid iseseisvalt ja ei karda teha vigu. Vigadest saad Sa õppida, aga plagiaat on tõsine eksimus ülikooli kõige olulisemate reeglite vastu ja ei aita Sind kuidagi edasi. 
                    </li>
                    <li>
                        Pingutad, et esitada kodutööd õigeaegselt ja alustad ülesannete tegemist varakult. 
                        Nii on väiksem risk, et ülesanded kuhjuvad semestri lõppu ja põneva pingutuse ja õppimise asemel saab sellest Sulle probleem. 
                    </li>
                    <li>
                        Annad meile regulaarset tagasisidet kursuse kohta, et teaksime, mis seisus Sina ja teised tudengid on ja vajadusel muudaksime programmi.
                    </li>
                </ul>
            </div>

            <form className="container" onSubmit={handleSubmit(onSubmit)}>
                <h1 className="subtitle form-question">
                    Kas selline kokkulepe sobib Sulle?
                </h1>
                <div className="control">
                    <label className="radio">
                        <input type="radio" name="agree" value="iLike" ref={register({required: true})}/>
                        Jah, väga hea diil, olen nõus!
                    </label>
                </div>
                <div className="control">
                    <label className="radio">
                        <input type="radio" name="agree" value="iAgree" ref={register({required: true})}/>
                        Jah, sobib!
                    </label>
                </div>
                <div className="control">
                    <label className="radio">
                        <input type="radio" name="agree" value="ratherYes" ref={register({required: true})}/>
                        Pigem jah, aga täpsustan igaks juhuks üle, kas (kirjuta küsimus):
                        <input className="input" type="text" name="ratherYesExplanation" ref={register(createConditionalRequire(getValues, "agree", "ratherYes"))}/>
                    </label>
                </div>
                <div className="control">
                    <label className="radio">
                        <input type="radio" name="agree" value="partially" ref={register({required: true})}/>
                        Mõnes asjas tahan üle küsida või jääda eriarvamusele 
                        <input className="input" type="text" name="partiallyExplanation" ref={register(createConditionalRequire(getValues, "agree", "partially"))}/>
                    </label>
                </div>
                <div className="control">
                    <label className="radio">
                        <input type="radio" name="agree" value="ratherNo" ref={register({required: true})}/>
                        Ei, mulle ei sobi, ootasin midagi muud
                        <input className="input" type="text" name="ratherNoExplanation" ref={register(createConditionalRequire(getValues, "agree", "ratherNo"))}/>
                    </label>
                </div>
                <div className="control">
                    <label className="radio">
                        <input type="radio" name="agree" value="no" ref={register({required: true})}/>
                        Ma vist olen täitsa vales kohas, mul on mure (kirjuta kindlasti kommentaar)
                        <textarea
                    className="textarea"
                    placeholder="Kirjuta oma mure siia"
                    name="noExplanation"
                    ref={register(createConditionalRequire(getValues, "agree", "no"))}
                />
                    </label>
                </div>

                {Object.keys(errors).length ? <div className="validation-error">
                    Jätkamiseks vasta palun kõigile küsimustele!
                </div> : null}
                <button className={`button is-large is-rounded take-test-button ${isLoading ? 'is-loading' : ''}`} disabled={isLoading}>JÄRGMINE →</button>
            </form>
        </section>
    </>);
};

export default MutualAgreement;
